import axios from "axios";
const PREPR_API = process.env.VUE_APP_PREPR_API;

export async function getClassicalOverview() {
  const res = await axios.post(PREPR_API, {
    query: `{
          CommonModel (slug: "classical-introduction") { 
                  title
                  heading
          text
                  main_image { 
                          url
                  }
                  right_section {
                          title
                          heading
                          main_image {
                                  url
                          }
                          button_text
                  }
          }
    }`
  });
  return res.data.data.CommonModel
}

export async function getClassicalGreekOverview() {
  const res = await axios.post(PREPR_API, {
    query: `{
          CommonModel (slug: "greek-overview") { 
                  heading
                  text
                  main_image { 
                          url
                  }
                  right_section {
                          heading
                          text
                          main_image {
                                  url
                          }
                          button_text
                  }
          }
    }`
  });
  return res.data.data.CommonModel
}

export async function getClassicalGreekReference() {
  const res = await axios.post(PREPR_API, {
    query: `{
          CommonModel (slug: "greek-references") { 
                  title
                  heading
                  text
          }
    }`
  });
  return res.data.data.CommonModel
}

export async function getClassicalEgyptOverview() {
  const res = await axios.post(PREPR_API, {
    query: `{
          CommonModel (slug: "egypt-overview") { 
                  heading
                  text
                  main_image { 
                          url
                  }
                  right_section { 
                          heading
                          text
                          main_image {
                                  url
                          }
                          button_text
                  }
          }
    }`
  });
  return res.data.data.CommonModel
}

export async function getClassicalEgyptReference() {
  const res = await axios.post(PREPR_API, {
    query: `{
          CommonModel (slug: "egyptian-references") { 
                  title
                  heading
                  text
          }
    }`
  });
  return res.data.data.CommonModel
}

export async function getClassicalRomanOverview() {
  const res = await axios.post(PREPR_API, {
    query: `{
          CommonModel (slug: "roman-overview") { 
                  title
                  heading
                  text
                  main_image { 
                          url
                  }
                  right_section {
                          title
                          heading
                          text
                          main_image {
                                  url
                          }
                          button_text
                  }
          }
    }`
  });
  return res.data.data.CommonModel
}

export async function getClassicalRomanReference() {
  const res = await axios.post(PREPR_API, {
    query: `{
          CommonModel (slug: "roman-references") { 
                  title
                  heading
                  text
          }
    }`
  });
  return res.data.data.CommonModel
}

export async function getClassicalUnlock() {
        const res = await axios.post(PREPR_API, {
          query: `{
            CommonUnlock (slug: "unlock-classical") { 
                title
                banner { 
                        title
                        heading
                        image { 
                                url
                        }
                        text
                        button_text
                }
                description { 
                        title
                        heading
                        image { 
                                url
                        }
                        text
                }
              }
            }`
        });
        return res.data.data.CommonUnlock;
      }